export default __webpack_public_path__ + "static/media/eye-invisible.fe5071a3.svg";